module.exports = __webpack_public_path__ + "img/img_my_identify_0.779c4acb.jpg";